define.alias("shared/components/shared/guidelines", "calendar/components/shared/guidelines");